import React from "react";

import { Input } from "@components/General/Form/input.component";
import { Label } from "@components/General/Form/label.component";

import ResultField, {
    ResultFieldProps,
} from "../ResultField/resultField.component";
import "./checkBoxresultField.scss";

type CheckBoxResultFieldProps = ResultFieldProps & {
    onCheck: () => void;
    isChecked: boolean;
    sku: string;
};

const CheckBoxResultField = ({
    copy,
    copyPostfix,
    sku,
    value,
    unit,
    sup,
    sm,
    md,
    lg,
    onCheck,
    isChecked,
}: CheckBoxResultFieldProps) => {
    return (
        <ResultField
            copy={copy}
            copyPostfix={copyPostfix}
            value={value}
            unit={unit}
            sup={sup}
            sm={sm}
            md={md}
            lg={lg}
        >
            <Label
                for={`acc-${sku}`}
                check
                className="pr-2 checkbox-result-field"
            >
                <Input
                    type="checkbox"
                    id={`acc-${sku}`}
                    checked={isChecked}
                    onChange={onCheck}
                    className="result"
                />
            </Label>
        </ResultField>
    );
};

export default CheckBoxResultField;
